// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__2pjQw","total":"Cart_total__3pLin","actions":"Cart_actions__1GOmr","button--alt":"Cart_button--alt__1Z2QQ","button":"Cart_button__fw1-t"};